import { all, takeEvery } from "redux-saga/effects";
import {
  ACCOUNT_VERIFICATION_REQUEST,
  FORGET_VALIDATE_OTP_REQUEST,
  GET_USER_REQUEST,
  LOGOUT,
  REGISTER_USER_REQUEST,
  RESET_PASSWORD_REQUEST,
  VALIDATE_OTP_REQUEST,
  EMAIL_VERIFICATION_REQUEST,
  REGISTER_EXISTING_USER_REQUEST,
  GET_EDITOR_REQUEST,
  REMOVE_EDITOR_REQUEST,
} from "../Actions/AuthActions";
import { TOAST_INIT } from "../Actions/ToastAction";
import {
  ResetPassSaga,
  LoginSaga,
  LogoutSaga,
  RegisterSaga,
  ValidateOtpSaga,
  ForgetValidateOtpSaga,
  AccountVerificationSaga,
  EmailVerificationSaga,
  AddExisitingUserSaga,
  editorSaga,
  editorRemoveSaga,
} from "./AuthSaga";
import { ToastSaga } from "./ToastSaga";
import {
  GET_ALL_USERS_REQUEST,
  GET_INVITED_USERS_REQUEST,
  GET_MY_PATIENT_DETAILS_REQUEST,
  GET_PRACTIONERS_REQUEST,
  GET_USERS_REQUEST,
  PRACTIONERS_DETAILS_REQUEST,
  SENT_INVITE_REQUEST,
  USERS_DETAILS_REQUEST,
  USER_STATUS_UPDATE_REQUEST,
  USERS_REMOVE_REQUEST,
  GET_USERS_EMAIL_REQUEST,
  GET_USER_PROGRAM_GRAPH_REQUEST,
  GET_USER_WATCH_GRAPH_REQUEST,
  PATIENT_REMOVE_REQUEST,
  GET_PRACTITIONERS_EMAIL_REQUEST,
  MAINTENANCE_MODE_REQUEST,
  GET_MAINTENANCE_MODE_REQUEST,
} from "../Actions/userAction";
import {
  allUserSaga,
  invitedUserSaga,
  inviteSaga,
  myPatientDetailSaga,
  practionerDetailSaga,
  practionerSaga,
  userDetailSaga,
  userSaga,
  userRemoveSaga,
  updateUserStatusSaga,
  getClientsEmailSaga,
  getUserProgramGraphSaga,
  getUserWatchGraphSaga,
  patientRemoveSaga,
  getPractitionersEmailSaga,
  maintenanceModeStatusSaga,
  getMaintenanceModeStatusSaga,
} from "./userSaga";
import {
  CREATE_PROGRAM_DETAILS_REQUEST,
  CREATE_PROGRAM_COMMITMENTS_REQUEST,
  UPLOAD_SANDBOX_REQUEST,
  GET_PROGRAM_PUBLISH_REQUEST,
  UPDATE_PROGRAM_STATUS_REQUEST,
  UPDATE_PROGRAM_DETAILS_REQUEST,
  UPDATE_PROGRAM_DAY_DETAILS_REQUEST,
  SEARCH_PROGRAM_REQUEST,
  UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST,
  REMOVE_PROGRAM_REQUEST,
  REMOVE_COMMITMENT_REQUEST,
  GET_EXPLORE_CONTENT_REQUEST,
  GET_PROGRAM_CATEGORY_REQUEST,
} from "../Actions/ProgramAction";
import {
  createProgramSaga,
  creatCommitmentsSaga,
  uploadSandBoxSaga,
  getProgramPublishSaga,
  updateProgramStatusSaga,
  updateProgramDetailsSaga,
  updateProgramDayDetailsSaga,
  programSearchSaga,
  updateProgramPublishStatusSaga,
  RemoveProgramSaga,
  RemoveCommitmentDetailsSaga,
  getExploreContentSaga,
  getProgramCategorySaga,
} from "./ProgramsSaga";
import {
  GET_FEEDBACK_REQUEST,
  REMOVE_FEEDBACK_REQUEST,
} from "../Actions/FeedBack";
import { RemoveFeedbackSaga, getFeedBackSaga } from "./FeedBackSaga";
import {
  createBulletinSaga,
  getBulletinDraftSaga,
  updateBulletinDraftSaga,
  publishedBulletinSaga,
  bulletinSearchSaga,
  draftBulletinActiveSaga,
  RemoveBulletinSaga,
} from "../Sagas/BulletinSaga";

import {
  CREATE_BULLETIN_REQUEST,
  GET_BULLETIN_DRAFT_REQUEST,
  UPDATE_BULLETIN_DRAFT_REQUEST,
  PUBLISHED_BULLETIN_STATUS_REQUEST,
  SEARCH_BULLETIN_REQUEST,
  DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST,
  REMOVE_BULLETIN_REQUEST,
} from "../Actions/BulletinAction";

import {
  activeExploreCategorySaga,
  createExploreCategorySaga,
  createExploreSaga,
  draftExploreActiveSaga,
  exploreSearchSaga,
  getExploreCategorySaga,
  getExploreSaga,
  publishedExploreSaga,
  updateExploreCategorySaga,
  updateExploreSaga,
  RemoveExploreSaga,
  RemoveCategorySaga,
  ReOrderContentSaga,
  copyContentSaga,
} from "./ExploreSaga";
import {
  REMOVE_EXPLORE_REQUEST,
  ACTIVE_EXPLORE_CATEGORY_REQUEST,
  CREATE_EXPLORE_CATEGORY_REQUEST,
  CREATE_EXPLORE_REQUEST,
  DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST,
  GET_EXPLORE_CATEGORY_REQUEST,
  GET_EXPLORE_REQUEST,
  PUBLISHED_EXPLORE_STATUS_REQUEST,
  SEARCH_EXPLORE_REQUEST,
  UPDATE_EXPLORE_CATEGORY_REQUEST,
  UPDATE_EXPLORE_REQUEST,
  REMOVE_CATEGORY_REQUEST,
  REORDER_CONTENT_REQUEST,
  COPY_CONTENT_REQUEST,
} from "../Actions/ExploreAction";
import {
  getFooterPageMobileSideSaga,
  getFooterPageSaga,
  updateFooterPageSaga,
  createFAQPageActionSaga,
  RemoveFAQSaga,
} from "./FooterPageSaga";
import {
  GET_FOOTER_PAGE_MOBILESIDE_REQUEST,
  GET_FOOTER_PAGE_REQUEST,
  UPDATE_FOOTER_PAGE_REQUEST,
  FAQ_CREATE_REQUEST,
  FAQ_REMOVE_REQUEST,
} from "../Actions/FooterPageAction";
import {
  getOverviewChartSaga,
  getPractitionerOverviewChartSaga,
} from "./OverviewSaga";
import {
  GET_PRACTITIONER_DETAIL_CHART_REQUEST,
  GET_PROGRAM_CHARTDATA_REQUEST,
} from "../Actions/OverviewAction";
import {
  GET_REPORT_GRAPH_REQUEST,
  GET_CANCER_TYPE_REQUEST,
} from "../Actions/ReportActions";
import { getReportGraphSaga, GetCancerTypesSaga } from "./ReportSaga";
function* rootSagas() {
  yield all([
    takeEvery(GET_USER_REQUEST, LoginSaga),
    takeEvery(REGISTER_USER_REQUEST, RegisterSaga),
    takeEvery(REGISTER_EXISTING_USER_REQUEST, AddExisitingUserSaga),
    takeEvery(VALIDATE_OTP_REQUEST, ValidateOtpSaga),
    takeEvery(FORGET_VALIDATE_OTP_REQUEST, ForgetValidateOtpSaga),
    takeEvery(RESET_PASSWORD_REQUEST, ResetPassSaga),
    takeEvery(ACCOUNT_VERIFICATION_REQUEST, AccountVerificationSaga),
    takeEvery(EMAIL_VERIFICATION_REQUEST, EmailVerificationSaga),
    takeEvery(LOGOUT, LogoutSaga),
    takeEvery(TOAST_INIT, ToastSaga),
    takeEvery(GET_USERS_REQUEST, userSaga),
    takeEvery(GET_PRACTIONERS_REQUEST, practionerSaga),
    takeEvery(USERS_DETAILS_REQUEST, userDetailSaga),
    takeEvery(GET_ALL_USERS_REQUEST, allUserSaga),
    takeEvery(GET_INVITED_USERS_REQUEST, invitedUserSaga),
    takeEvery(GET_MY_PATIENT_DETAILS_REQUEST, myPatientDetailSaga),
    takeEvery(SENT_INVITE_REQUEST, inviteSaga),
    takeEvery(PRACTIONERS_DETAILS_REQUEST, practionerDetailSaga),
    takeEvery(CREATE_BULLETIN_REQUEST, createBulletinSaga),
    takeEvery(GET_BULLETIN_DRAFT_REQUEST, getBulletinDraftSaga),
    takeEvery(UPDATE_BULLETIN_DRAFT_REQUEST, updateBulletinDraftSaga),
    takeEvery(CREATE_EXPLORE_REQUEST, createExploreSaga),
    takeEvery(CREATE_PROGRAM_DETAILS_REQUEST, createProgramSaga),
    takeEvery(GET_EXPLORE_REQUEST, getExploreSaga),
    takeEvery(UPDATE_EXPLORE_REQUEST, updateExploreSaga),
    takeEvery(CREATE_PROGRAM_COMMITMENTS_REQUEST, creatCommitmentsSaga),
    takeEvery(UPLOAD_SANDBOX_REQUEST, uploadSandBoxSaga),
    takeEvery(GET_PROGRAM_PUBLISH_REQUEST, getProgramPublishSaga),
    takeEvery(UPDATE_PROGRAM_STATUS_REQUEST, updateProgramStatusSaga),
    takeEvery(UPDATE_PROGRAM_DETAILS_REQUEST, updateProgramDetailsSaga),
    takeEvery(UPDATE_PROGRAM_DAY_DETAILS_REQUEST, updateProgramDayDetailsSaga),
    takeEvery(PUBLISHED_EXPLORE_STATUS_REQUEST, publishedExploreSaga),
    takeEvery(PUBLISHED_BULLETIN_STATUS_REQUEST, publishedBulletinSaga),
    takeEvery(SEARCH_PROGRAM_REQUEST, programSearchSaga),
    takeEvery(SEARCH_BULLETIN_REQUEST, bulletinSearchSaga),
    takeEvery(SEARCH_EXPLORE_REQUEST, exploreSearchSaga),
    takeEvery(CREATE_EXPLORE_CATEGORY_REQUEST, createExploreCategorySaga),
    takeEvery(GET_EXPLORE_CATEGORY_REQUEST, getExploreCategorySaga),
    takeEvery(UPDATE_EXPLORE_CATEGORY_REQUEST, updateExploreCategorySaga),
    takeEvery(DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST, draftExploreActiveSaga),
    takeEvery(DRAFT_BULLETIN_ACTIVE_STATUS_REQUEST, draftBulletinActiveSaga),
    takeEvery(
      UPDATE_PROGRAM_PUBLISH_STATUS_REQUEST,
      updateProgramPublishStatusSaga
    ),
    takeEvery(ACTIVE_EXPLORE_CATEGORY_REQUEST, activeExploreCategorySaga),
    takeEvery(UPDATE_FOOTER_PAGE_REQUEST, updateFooterPageSaga),
    takeEvery(FAQ_CREATE_REQUEST, createFAQPageActionSaga),
    takeEvery(FAQ_REMOVE_REQUEST, RemoveFAQSaga),
    takeEvery(GET_FOOTER_PAGE_REQUEST, getFooterPageSaga),
    takeEvery(GET_FEEDBACK_REQUEST, getFeedBackSaga),
    takeEvery(REMOVE_PROGRAM_REQUEST, RemoveProgramSaga),
    takeEvery(USERS_REMOVE_REQUEST, userRemoveSaga),
    takeEvery(PATIENT_REMOVE_REQUEST, patientRemoveSaga),
    takeEvery(USER_STATUS_UPDATE_REQUEST, updateUserStatusSaga),
    takeEvery(GET_FOOTER_PAGE_MOBILESIDE_REQUEST, getFooterPageMobileSideSaga),
    takeEvery(GET_USERS_EMAIL_REQUEST, getClientsEmailSaga),
    takeEvery(REMOVE_COMMITMENT_REQUEST, RemoveCommitmentDetailsSaga),
    takeEvery(GET_PROGRAM_CHARTDATA_REQUEST, getOverviewChartSaga),
    takeEvery(GET_EXPLORE_CONTENT_REQUEST, getExploreContentSaga),
    takeEvery(GET_USER_PROGRAM_GRAPH_REQUEST, getUserProgramGraphSaga),
    takeEvery(GET_USER_WATCH_GRAPH_REQUEST, getUserWatchGraphSaga),
    takeEvery(GET_REPORT_GRAPH_REQUEST, getReportGraphSaga),
    takeEvery(REMOVE_BULLETIN_REQUEST, RemoveBulletinSaga),
    takeEvery(REMOVE_EXPLORE_REQUEST, RemoveExploreSaga),
    takeEvery(GET_CANCER_TYPE_REQUEST, GetCancerTypesSaga),
    takeEvery(
      GET_PRACTITIONER_DETAIL_CHART_REQUEST,
      getPractitionerOverviewChartSaga
    ),
    takeEvery(REMOVE_FEEDBACK_REQUEST, RemoveFeedbackSaga),
    takeEvery(GET_PROGRAM_CATEGORY_REQUEST, getProgramCategorySaga),
    takeEvery(GET_EDITOR_REQUEST, editorSaga),
    takeEvery(REMOVE_EDITOR_REQUEST, editorRemoveSaga),
    takeEvery(GET_PRACTITIONERS_EMAIL_REQUEST, getPractitionersEmailSaga),
    takeEvery(REMOVE_CATEGORY_REQUEST, RemoveCategorySaga),
    takeEvery(REORDER_CONTENT_REQUEST, ReOrderContentSaga),
    takeEvery(COPY_CONTENT_REQUEST, copyContentSaga),
    takeEvery(GET_MAINTENANCE_MODE_REQUEST, getMaintenanceModeStatusSaga),
    takeEvery(MAINTENANCE_MODE_REQUEST, maintenanceModeStatusSaga),
  ]);
}

export default rootSagas;
